// import './App.css';
// import Navbar from './components/navbar/Navbar';
// import Banner from './components/banner/Banner';
// import Features from './components/features/Features';
// import Project from './components/project/Project';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import ImageGallery from './components/project/ImageGallery';

// import Resume from './components/resume/Resume';
// import Contact from './components/contact/Contact';
// import Footer from './components/footer/Footer';

// function App() {
//   return (
//     <Router>
//       <div className="w-full h-auto bg-bodyColor text-lightText px-4">
//         <div className="max-w-screen-xl mx-auto">
//           <Navbar />
//           <Routes>
//             <Route
//               path="/"
//               element={
//                 <>
//                   <Banner />
//                   <Features />
//                   <Project />
//                   <Resume />
//                   <Contact />
//                 </>
//               }
//             />
//             <Route path="/gallery" element={<ImageGallery />} />
//           </Routes>
//           <Footer />

//         </div>
//       </div>
//     </Router>
//   );
// }

// export default App;

import './App.css';
import Navbar from './components/navbar/Navbar';
import Banner from './components/banner/Banner';
import Features from './components/features/Features';
import Project from './components/project/Project';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ImageGallery from './components/project/ImageGallery'; // Assuming ImageGallery component exists
import VideoGallery from './components/project/VdoGallery';  // Added for video gallery route
import Resume from './components/resume/Resume';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';


function App() {
  return (
    <Router>
      <div className="w-full h-auto bg-bodyColor text-lightText px-4">
        <div className="max-w-screen-xl mx-auto">
          <Navbar />
          <Routes>
            {/* Home Route */}
            <Route
              path="/"
              element={
                <>
                  <Banner />
                  <Features />
                  <Project />
                  <Resume />
                  <Contact />
                </>
              }
            />

            {/* Specific Route for the Image Gallery */}
            <Route path="/gallery" element={<ImageGallery />} />

            {/* Added Route for Video Gallery */}
            <Route path="/video-gallery" element={<VideoGallery />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;

